import {
    useMemo,
} from 'react'
import useCreateSkyNetDomainRoutes from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    createRoutesConfig,
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    App,
} from 'app/enums/domain.enums'

export default function useDeploymentRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const SkyNetDomainRoutes = useCreateSkyNetDomainRoutes()()

    return useMemo(() => {
        const config = {
            path: [],
            Deployments: {
                route: App.Deployments,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        SkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
